import type { PublicApiKey } from '#packages/apilib';
import type { createAscendApi } from './ascendPublicApi';

export const AscendApiKey: PublicApiKey<typeof createAscendApi> = {
  name: 'AscendApi',
  public: true,
};
